import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';

import { Typography, Link, InputAdornment, IconButton, Box } from '@mui/material';
import { ReactComponent as ShowPassIcon } from '../../../../assets/images/showPass.svg';
import { ReactComponent as ShowPassOffIcon } from '../../../../assets/images/showPassOff.svg';
import { CustomInput } from '../../../../components/CustomInput';
import { CustomButton } from '../../../../components/CustomButton';
import { WrapPage } from '../WrapPage';
import { ROUTES } from '../../../../constants/routes';
import { email, password } from '../yupFieldsValidation';
import { userLogIn } from '../../../../store/user/actions';

const validationSchema = yup.object({
  username: email,
  password: password
});

export const LoginPage = () => {
  const [showPass, setShowPass] = useState(true);
  const [showError, setShowError] = useState(false);
  const dispatch = useDispatch();

  const { handleSubmit, values, handleChange, errors, isSubmitting, resetForm, handleBlur } =
    useFormik({
      initialValues: {},
      validationSchema: validationSchema,
      validateOnChange: false,
      validateOnBlur: true,
      onSubmit: (values) => {
        if (isSubmitting) {
          let formData = new FormData();
          formData.append('username', values.username);
          formData.append('password', values.password);
          dispatch(userLogIn(formData, setShowError, resetForm));
        }
      }
    });

  return (
    <WrapPage>
      <Typography
        variant="h2"
        sx={{ color: 'text.primary', marginBottom: '30px', marginTop: '86px', fontSize: '48px' }}>
        Войти
      </Typography>
      {showError && (
        <Typography variant="subtitle2" sx={{ color: 'error.main', marginBottom: '30px' }}>
          E-mail и (или) пароль неверный. Попробуйте снова
        </Typography>
      )}

      <form onSubmit={handleSubmit}>
        <CustomInput
          name="username"
          value={values.username}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors['username']}
          helperText={errors['username']}
          type="text"
          placeholder="E-mail"
          sx={{ marginBottom: '16px', width: '100%' }}
        />

        <CustomInput
          name="password"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Пароль"
          type={showPass ? 'password' : 'text'}
          sx={{ marginBottom: '16px', width: '100%' }}
          error={errors['password']}
          helperText={errors['password']}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPass(!showPass)}
                  data-testid="PasswordVisibility"
                >
                  {!showPass ? <ShowPassOffIcon /> : <ShowPassIcon />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'baseline' }}>
          <Link
            href={ROUTES.RECOVER_PASSWORD_EMAIL}
            sx={{ margin: '16px 0 30px 0' }}
            variant="form">
            Забыли пароль?
          </Link>
          <CustomButton type="submit" size="large" variant="contained">
            Войти
          </CustomButton>
        </Box>
      </form>
    </WrapPage>
  );
};
